class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this),
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");

    this.onClickOutside = this.onClickOutside.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.syncListeners = this.syncListeners.bind(this);

    this.mainDetailsToggle.addEventListener("toggle", this.syncListeners);

    this.syncListeners();
  }

  connectedCallback() {
    this.syncListeners();
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.onClickOutside);
    document.removeEventListener("keyup", this.onKeyUp);
  }

  syncListeners() {
    if (this.mainDetailsToggle.open) {
      document.addEventListener("click", this.onClickOutside);
      document.addEventListener("keyup", this.onKeyUp);
    } else {
      document.removeEventListener("click", this.onClickOutside);
      document.removeEventListener("keyup", this.onKeyUp);
    }
  }

  onToggle() {
    super.onToggle();

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop",
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }

  onClickOutside(event) {
    if (!this.contains(event.target)) {
      this.close();
    }
  }

  onKeyUp(event) {
    if (event.key === "Escape") {
      this.close();
      this.mainDetailsToggle.querySelector("summary")?.focus();
    }
  }

  close() {
    super.close();
    document.removeEventListener("click", this.onClickOutside);
    document.removeEventListener("keyup", this.onKeyUp);
  }
}

customElements.define("header-menu", HeaderMenu);
